import numeral from 'numeral'
numeral.locale('pt-br');

import {Notification} from 'element-ui'

export const META_NAO_BATEU_VALUE = 0
export const META_BATEU_VALUE = 1
export const META_NAO_APURADA_VALUE = 2

export const META_NAO_BATEU_COLOR = '#ff4444'
export const META_BATEU_COLOR = '#007E33'
export const META_NAO_APURADA_COLOR = '#0099CC'

export const icon_requisito = requisito_id => requisito_id === 1 ? 'fa-arrow-up' : 'fa-arrow-down'

export const format_value = (valor) => numeral(valor).format('0,0,0,0,0,0.00')

export const valor_realizado = (realizado) => realizado === null ? 'NR' : format_value(realizado);

export const is_parent = (parent_id) => _.isUndefined(parent_id)

export const style_bate_meta = (bateu, realizado) => {
  if (realizado === null) {
    return 'cell-sem-resposta';
  }
  return bateu ? 'cell-bateu' : 'cell-nao-bateu'
}

export const error_form_transform = (error) => {
  if (!_.isObjectLike(error.response)) {
    return []
  }
  const serverErrors = error.response.data.errors
  let errors = []
  for (const prop in serverErrors) {
    errors[prop] = _.head(serverErrors[prop])
  }
  return errors
}

export const colorByMeta = (bateu) => {
  let color = ''

  switch (bateu) {
    case META_NAO_BATEU_VALUE:
      color = META_NAO_BATEU_COLOR
      break
    case META_BATEU_VALUE:
      color = META_BATEU_COLOR
      break
    default:
      color = META_NAO_APURADA_COLOR
  }
  return color
}

export const competenciaStatusLabel = (status) => {
  return status === 1 ? 'Aberta' : 'Fechada'
}

export const competenciaIsOpen = (status) => {
  return status === 1
}

export const trataErrors = (error) => {

  const {response} = error

  if(!response)
  {
    console.log(error)
    return
  }

  const { status ,data } = response
  if (status == 422) {
    return
  }
  const message = status === 402 ? data.msg : "Erro interno, contate o suporte."
  Notification.error(message)
}


export const imgApi = (img) =>  `${process.env.API_URI}/storage/${img}`
export const openAside = () =>  document.body.classList.toggle('aside-menu-hidden')



// WEBPACK FOOTER //
// ./src/domain/utils.js